export default __webpack_public_path__ + "static/media/dp-map-filter-reduce.4d859ace.png";